import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { QTooltipProps } from 'quasar'
import { computed } from 'vue'

interface IProps {
  label: string
  color?: string // for background
  textColor?: string
  position?: 'left' | 'right' | 'top' | 'bottom'
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KTooltip', inheritAttrs: false },
  __name: 'KTooltip',
  props: {
    label: {},
    color: { default: 'dark-bg-20' },
    textColor: { default: 'static-light' },
    position: { default: 'top' }
  },
  setup(__props: any) {



const props = __props

const positionObj = computed(() => {
  let anchor = ''
  let self = ''
  switch (props.position) {
    case 'left':
      anchor = 'center left'
      self = 'center right'
      break
    case 'right':
      anchor = 'center right'
      self = 'center left'
      break
    case 'top':
      anchor = 'top middle'
      self = 'bottom middle'
      break
    case 'bottom':
      anchor = 'bottom middle'
      self = 'top middle'
      break
  }
  return { anchor, self } as Partial<QTooltipProps>
})

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_component_q_tooltip, _mergeProps({
    class: ["k-tooltip", ['k-tooltip--' + __props.position, 'text-' + __props.color]],
    offset: [10, 8],
    anchor: positionObj.value.anchor,
    self: positionObj.value.self
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", {
          class: _normalizeClass(['text-' + __props.textColor])
        }, _toDisplayString(__props.label), 3 /* TEXT, CLASS */)
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["class", "anchor", "self"]))
}
}

})